import {
  Box,
  Grid,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import EmailIcon from "@material-ui/icons/Email";
import FacebookIcon from "@material-ui/icons/Facebook";
import ImageIcon from "@material-ui/icons/Image";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
// import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import TelegramIcon from "@material-ui/icons/Telegram";
import UndoIcon from "@material-ui/icons/Undo";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import React from "react";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  WhatsappShareButton,
} from "react-share";
import ShortLinkInput from "./ShortLinkInput";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#fff",
    borderRadius: "1rem",
    margin: "2rem 0",
    padding: "2rem 0",
  },
  textBox: {
    width: "80%",
    margin: "1rem auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  boldText: {
    fontFamily: "Vazir",
    marginBottom: "2rem",
  },
  iconBox: {},
  icon: {
    fontSize: "4rem",
  },
  linkBox2: {
    margin: "1rem auto",
    display: "flex",
    alignItems: "center",
  },
}));

export default function DetailsBox({ link, slug }) {
  const classes = useStyles();
  let myLink = link;

  if (!link) {
    myLink = `https://agapengo.com/organizations/charities/${slug}`;
  }

  return (
    <Grid container className={classes.root} direction="column">
      <Grid item>
        <Box className={classes.textBox}>
          <TelegramShareButton url={myLink}>
            <IconButton
              aria-label="delete"
              style={{
                backgroundColor: "#D4DEF0",
              }}
            >
              <TelegramIcon
                style={{ color: "#356db5" }}
                className={classes.icon}
              />
            </IconButton>
          </TelegramShareButton>
          <EmailShareButton url={myLink}>
            <IconButton
              aria-label="delete"
              style={{
                backgroundColor: "#F8D1DD",
              }}
            >
              <EmailIcon
                style={{ color: "#f32852" }}
                className={classes.icon}
              />
            </IconButton>
          </EmailShareButton>
          <LinkedinShareButton url={myLink}>
            <IconButton
              aria-label="delete"
              style={{
                backgroundColor: "#CAE0F0",
              }}
            >
              <LinkedInIcon
                style={{ color: "#0073b2" }}
                className={classes.icon}
              />
            </IconButton>
          </LinkedinShareButton>
          <WhatsappShareButton url={myLink}>
            <IconButton
              aria-label="delete"
              style={{
                backgroundColor: "#CCEEDA",
              }}
            >
              <WhatsAppIcon
                className={classes.icon}
                style={{ color: "#0dc143" }}
              />
            </IconButton>
          </WhatsappShareButton>
          <FacebookShareButton url={myLink}>
            <IconButton
              aria-label="delete"
              style={{
                backgroundColor: "#BDCDEC",
              }}
            >
              <FacebookIcon
                className={classes.icon}
                style={{ color: "#4267B2", borderRadius: "50%" }}
              />
            </IconButton>
          </FacebookShareButton>
        </Box>
      </Grid>
      <Grid item>
        <Box className={classes.linkBox2}>
          <ShortLinkInput link={myLink} />
          <Box display="flex" alignItems="center">
            <Typography
              variant="h6"
              style={{ fontFamily: "Vazir-Bold", color: "#009693" }}
            >
              دانلود :
            </Typography>
            <a
              rel="noreferrer"
              target="_blank"
              href={`https://agapengo.com/api/organizations/${slug}?format=jpg`}
            >
              <IconButton aria-label="delete">
                <ImageIcon style={{ color: "#009693", fontSize: "2.5rem" }} />
              </IconButton>
            </a>
            {/* <a
              rel="noreferrer"
              target="_blank"
              href={`https://agapengo.com/api/organizations/${slug}?format=pdf`}
            >
              <IconButton aria-label="delete">
                <PictureAsPdfIcon
                  style={{ color: "#009693", fontSize: "2.5rem" }}
                />
              </IconButton>
            </a> */}
          </Box>
          <Box
            style={{
              position: "absolute",
              bottom: "50px",
              left: "50px",
            }}
          >
            <Box style={{ position: "relative" }}>
              <UndoIcon
                style={{
                  position: "absolute",
                  fontSize: "25px",
                  left: "50%",
                  top: "-15px",
                  transform: "rotate(80deg)",
                  color: "#2e4cff",
                }}
              />
            </Box>
            <Typography variant="caption" style={{ color: "#2e4cff" }}>
              برای اشتراک گذاری پست در شبکه اجتماعی دانلود کنید
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
